import Dialog from "../../GenericComponents/dialog"

interface OverlayProps {
    title: string;
    content: React.ReactNode | string;
    onAcknowledge?: () => void;
    // actionPerformedOnBtnClick?: () => void;  I could only think of this generic name for the overlay button
    isOpen?: boolean;
    onClose?: () => void;
    buttonLabel?: string;
}

const Overlay : React.FC<OverlayProps> = ({
    title,
    content,
    onAcknowledge,
    isOpen = true,
    onClose,
    buttonLabel,
}) =>  {

    const actionOnBtnClick = async () => {
        if (onAcknowledge) await onAcknowledge();
        // if (onClose) onClose();
    };

    const handleClose = async () => {
        if (onClose) onClose();
    };

    return (
        <Dialog
            width={350}
            minHeight={42}
            isOpen={isOpen}
            title={title}
            height={'auto'}
            onClose={() => handleClose()}
            buttons={[
                {
                    label: buttonLabel || 'Default Label',
                    onClick: () => { actionOnBtnClick() },
                    className: 'app-button ui-button ui-corner-all ui-widget',
                },
            ]}>
            <span className='releaseNotesList'>
                {content}
            </span>
        </Dialog>
    )
}
export default Overlay